import axios, { AxiosInstance, AxiosError, InternalAxiosRequestConfig } from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api: AxiosInstance = axios.create({
  baseURL: API_BASE,
});

// Add JWT token to every request
api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem('pourix_token');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors globally
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('pourix_token');
      localStorage.removeItem('pourix_user');
      localStorage.removeItem('pourix_org');
      localStorage.removeItem('pourix_role');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
